import { EmailPriority } from "@enums/emailPriority.enum";
import { Model } from "@interfaces/model.interface";

export interface EmailTemplate extends Model {
	css: string;
	design: any;
	emailPriority: EmailPriority;
	html: string;
	notes: string;
	senderEmailAddress: string;
	senderName: string;
	subject: string;
	templateName: string;
}

export class EmailTemplate implements EmailTemplate {
	css = "";
	emailPriority: EmailPriority = 0;
	html = "";
	notes = "";
	senderEmailAddress = "";
	senderName = "";
	subject = "";
	templateName = "";

	constructor(data?: Partial<EmailTemplate>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}